import React from "react";
import { imageCardList } from "../../../data/imageCardList";
import Container from "../../layout/Container";
import ImageCard from "./ImageCard";

const ImageCardList = ({ title = null, imageCards }) => {
  return (
    <Container>
      {title && (
        <h3 className="mt-9 mb-8 font-pop text-2xl font-medium uppercase">
          {title}
        </h3>
      )}
      <div className="mb-12 flex flex-row items-center justify-between gap-4">
        {imageCardList.map((item) => (
          <ImageCard key={item.id} imageUrl={item.imageUrl} />
        ))}
      </div>
    </Container>
  );
};

export default ImageCardList;
